import { type ReactNode } from 'react'
import { Icon, type IconName } from '#app/components/ui/icon.tsx'
import { cn } from '#app/utils/cn.ts'
const variants = {
	info: {
		icon: 'info-circled' as IconName,
		container: 'border-blue-500/40 bg-blue-50 dark:bg-blue-950/30',
		iconColor: 'text-blue-600 dark:text-blue-400',
	},
	warning: {
		icon: 'exclamation-triangle' as IconName,
		container: 'border-warning-border bg-warning-background',
		iconColor: 'text-warning-foreground',
	},
	tip: {
		icon: 'check-circled' as IconName,
		container: 'border-green-500/40 bg-green-50 dark:bg-green-950/30',
		iconColor: 'text-green-600 dark:text-green-400',
	},
} as const

export type CalloutType = keyof typeof variants

export function Callout({
	type = 'info',
	className,
	children,
}: {
	type?: CalloutType
	className?: string
	children: ReactNode
}) {
	const variant = variants[type]

	return (
		<div
			className={cn(
				'flex gap-3 rounded-lg border-l-4 p-4',
				variant.container,
				className,
			)}
		>
			<Icon
				name={variant.icon}
				size="md"
				className={cn('mt-0.5 shrink-0', variant.iconColor)}
			/>
			<div className="text-sm leading-relaxed [&_a]:font-medium [&_a]:underline [&_a]:underline-offset-2 [&>p]:m-0">
				{children}
			</div>
		</div>
	)
}
